import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildSwampHut: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const size = 5;
    const stiltHeight = 4;
    const wallHeight = 3;
    const posts: [number, number][] = [
        [0, 0],
        [size - 1, 0],
        [0, size - 1],
        [size - 1, size - 1],
    ];

    for (const [dx, dz] of posts) {
        brush.column(dx, dz, 0, stiltHeight - 1, BLOCK.StructureLog);
    }
    brush.lineX(1, size - 2, stiltHeight - 1, 0, BLOCK.Planks);
    brush.lineX(1, size - 2, stiltHeight - 1, size - 1, BLOCK.Planks);
    brush.lineZ(0, stiltHeight - 1, 1, size - 2, BLOCK.Planks);
    brush.lineZ(size - 1, stiltHeight - 1, 1, size - 2, BLOCK.Planks);

    const floorY = stiltHeight;
    brush.layer(0, size - 1, 0, size - 1, floorY, BLOCK.Planks);
    brush.perimeter(
        0,
        size - 1,
        floorY + 1,
        floorY + wallHeight,
        0,
        size - 1,
        BLOCK.DarkPlanks,
        (x, y, z) => {
            const relativeY = y - floorY;
            const isDoor = relativeY <= 2 && x === 2 && z === 0;
            const isWindow = relativeY === 2 && z === 2 && x === size - 1;
            return !isDoor && !isWindow;
        },
    );
    for (const [dx, dz] of posts) {
        brush.column(dx, dz, floorY + 1, floorY + wallHeight, BLOCK.StructureLog);
    }

    const roofBase = floorY + wallHeight + 1;
    brush.layer(-1, size, 0, size - 1, roofBase, BLOCK.Thatch);
    brush.layer(0, size - 1, 1, size - 2, roofBase + 1, BLOCK.Thatch);
    brush.lineX(0, size - 1, roofBase + 2, 2, BLOCK.StructureLog);

    brush.block(0, floorY, 0, BLOCK.MossBlock);
    brush.block(size - 1, floorY, size - 1, BLOCK.MossBlock);
    brush.column(1, size - 2, roofBase + 1, roofBase + 3, BLOCK.Stone);
};
